/* eslint-disable no-useless-catch */
import api from '../../../api'

const actions = {
  async signup(context, payload) {
    return api.signup.create(payload)
  },

  async verifyOrganization(context, payload) {
    const { name, domain, recaptcha } = payload
    return await api.signup.verifyOrganization({ name, domain, recaptcha })
  },
}

export default actions
